import { useMemo } from 'react'
import { VatType } from '../config/i18nConfig'
import { getI18NName } from '../components/Combobox/i18n/I18NCombobox'
import { useTranslation } from 'react-i18next'
import useGlobalContext from './useGlobalContext'

type ReturnProps = {
    loaded: boolean
    vatTypes: VatType[]
    defaultVatType: VatType
    getVatType: (id: string) => VatType
    getVatTypeName: (id: string) => string
}

export default function useVatTypes(): ReturnProps {
    const { i18n } = useTranslation()
    const { loaded, entities } = useGlobalContext('vatTypes')

    const vatTypes: VatType[] = useMemo(() => entities?.sort((a, b) => (a.position || 1000) - (b.position || 1000)) || [], [entities])
    const defaultVatType: VatType = useMemo(() => (vatTypes.length > 0 ? vatTypes[0] : undefined), [vatTypes])

    const getVatType = (id: string) => vatTypes.find(value => value.id === id)
    const getVatTypeName = (id: string) =>
        getI18NName(
            (vatTypes || []).find(value => value.id === id),
            i18n.language,
        )

    return { loaded, vatTypes, defaultVatType, getVatType, getVatTypeName }
}
